// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import { Theme } from '@mui/material/styles';

const styles = (theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column' as const,
    alignItems: 'center',
    gap: theme.spacing(1.5),
    maxWidth: theme.spacing(60),
    padding: theme.spacing(0, 2),
    textAlign: 'center' as const,
  },
  title: {
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.text.primary,
  },
  detail: {
    color: theme.palette.text.secondary,
  },
  retryButton: {
    textTransform: 'none' as const,
  },
});

export default styles;
